module.exports = __webpack_public_path__ + "static/kube-environment-2256f55b978a889d2f9035dce815187a.svg";